import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CalculationKeynameEnum } from '../../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { CreateNewCalculationFormFactory } from './create-new-calculation-form.factory';
import { Subscription } from 'rxjs';
import {
  CalculationCreationOptions,
} from '../../../../../../../../common/src/options/calculations/calculation-creation.options';
import { CalculationsApiController } from '../../api-controllers/calculations.api-controller';
import { MenuService } from '../../../core/services/menu.service';
import { CalculationKeynameOptionsFactory } from '../../factories/calculation-keyname-options.factory';
import { CalculationStore } from '../../stores/calculation.store';
import { UntypedFormControl } from '@angular/forms';
import {AdvancedForm, AdvancedFormControl} from "@magieno/angular-advanced-forms";

import { AdvancedFormButton } from "@magieno/angular-advanced-forms";
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';
import { FlagEnum } from '../../../core/enums/flag.enum';
import { FlagManager } from '../../../core/managers/flag.manager';
import { LoggingService } from '../../../core/services/logging.service';

import { AdvancedForm as MagienoAdvancedForm } from '@magieno/angular-advanced-forms';

@Component({
  selector: 'app-create-new-calculation',
  templateUrl: './create-new-calculation.component.html',
  styleUrls: ['./create-new-calculation.component.scss'],
  standalone: false,
})
export class CreateNewCalculationComponent implements OnInit, OnDestroy {

  formServiceOnButtonClickSubscription: Subscription;
  cardCalculationDetails: { name: string, value: string, title: string, text: string, iconPath: string }[];
  public readonly form: AdvancedForm<CalculationCreationOptions> = this.formFactory.create();
  public readonly magienoForm: MagienoAdvancedForm<CalculationCreationOptions> = this.formFactory.createMagienoForm();
  private calculationKeyname: CalculationKeynameEnum;

  constructor(public menuService: MenuService,
              private readonly calculationsApiController: CalculationsApiController,
              private readonly calculationKeynameOptionsFactory: CalculationKeynameOptionsFactory,
              private readonly router: Router,
              private readonly calculationStore: CalculationStore,
              private readonly route: ActivatedRoute,
              private readonly flagManager: FlagManager,
              private readonly loggingService: LoggingService,
              public readonly formFactory: CreateNewCalculationFormFactory) {

    this.cardCalculationDetails = [];
    if (this.flagManager.isActive(FlagEnum.CalculationsSalaryDividend)) {
      this.cardCalculationDetails.push({
        name: 'calculationKeyname',
        value: CalculationKeynameEnum.SalaryDividendSimulation,
        title: 'Salaire-Dividende',
        text: 'Le calcul « Rémunération : Salaire vs Dividende » permet de calculer la proportion optimale de dividendes et de salaires que doit verser une société afin de minimiser la charge fiscale. Le calcul effectue des milliers simulations pour trouver le scénario optimal.',
        iconPath: '../../../assets/images/dividends_vs_salary.svg',
      });
    }
    if (this.flagManager.isActive(FlagEnum.CalculationsRrsp)) {
      this.cardCalculationDetails.push({
        name: 'calculationKeyname',
        value: CalculationKeynameEnum.RrspSimulation,
        title: 'REER',
        text: 'Le calcul « REER » permet de calculer la proportion optimale de REER à prendre pour optimiser l\'impôt. Le calcul effectue des milliers simulations pour trouver le scénario optimal.',
        iconPath: '../../../assets/images/rrsp.svg',
      });
    }
    
    if (this.flagManager.isActive(FlagEnum.CalculationsSection84_1)) {
      this.cardCalculationDetails.push({
        name: 'calculationKeyname',
        value: CalculationKeynameEnum.Section84_1,
        title: 'Vente d\'actions',
        text: 'L\'outils "Vente d\'actions" permet de calculer les conséquences fiscales de la vente des actions d\'une société telles qu\'un gain ou une perte en capital. L\'outils détermine aussi le montant du dividende réputé lorsque les conditions de l\'article 84.1 L.I.R. sont rencontrées.',
        iconPath: '../../../assets/images/shares_selling.svg',
      });
    }
    if (this.flagManager.isActive(FlagEnum.CalculationsRollover)) {
      this.cardCalculationDetails.push({
        name: 'calculationKeyname',
        value: CalculationKeynameEnum.Rollover,
        title: 'Roulement',
        text: 'Le roulement fiscal consiste à transférer un bien à une société canadienne dans le but de reporter son imposition.',
        iconPath: '../../../assets/images/rollover.svg',
      });
    }
    if (this.flagManager.isActive(FlagEnum.CalculationsRRQ)) {
      this.cardCalculationDetails.push({
        name: 'calculationKeyname',
        value: CalculationKeynameEnum.RRQ,
        title: 'RRQ',
        text: 'Le calcul de RRQ.',
        iconPath: '../../../assets/images/brain.svg',
      });
    }

  }

  getTitleFormControl(): UntypedFormControl {
    return this.form.get('title') as UntypedFormControl;
  }

  getCalculationKeynameFormControl(): UntypedFormControl {
    return this.form.get('calculationKeyname') as UntypedFormControl;
  }

  ngOnInit(): void {
    // Right away, we want to form to be set as loading.
    this.form.lifecycleStatus = FormLifecycleStatusEnum.Loading;

    // This following method registers an observable on any button clicked in the form. Each button has an id
    // and that's how we know which button was clicked on.
    this.formServiceOnButtonClickSubscription = this.form.buttonClick$.subscribe(async (button: AdvancedFormButton) => {
      switch (button.id) {
        case 'CREATE':
          await this.create();
          break;
      }
    });

    this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;

    (this.form.formElements.calculationKeyname as AdvancedFormControl<CalculationKeynameEnum, CalculationKeynameEnum, CalculationKeynameEnum>).setNormalizedValue(CalculationKeynameEnum.Section84_1);

    this.route.queryParams.subscribe((params) => {
      if (params.default && Object.values(CalculationKeynameEnum).includes(params.default)) {
        (this.form.formElements.calculationKeyname as AdvancedFormControl<CalculationKeynameEnum, CalculationKeynameEnum, CalculationKeynameEnum>).setNormalizedValue(params.default);
      }
    });


  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  async create() {
    try {
      const magienoValidationErrors = await this.magienoForm.validate();
      const validationErrors = await this.form.validate();
      if (validationErrors && validationErrors.length > 0) {
        this.form.setButtonLifecycleStatus(FormLifecycleStatusEnum.ReadyForInput);
        this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
        return;
      }

      const calculationKeyname = this.form.value.calculationKeyname;
      if (!calculationKeyname) {
        this.loggingService.error('Calculation Keyname not defined. Cannot continue');
        return;
      }

      this.form.lifecycleStatus = FormLifecycleStatusEnum.Loading;

      const options = this.form.value;

      const model = await this.calculationsApiController.create(options);

      this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;

      switch (calculationKeyname) {
        case CalculationKeynameEnum.Section84_1:
        case CalculationKeynameEnum.Rollover:
        case CalculationKeynameEnum.RRQ:
        case CalculationKeynameEnum.SalaryDividendSimulation:
        case CalculationKeynameEnum.RrspSimulation:
          await this.calculationStore.save(model.id, model);

          return await this.router.navigate([calculationKeyname, model.id], {
            relativeTo: this.route.parent,
          });
          break;
        default:
          this.loggingService.error('Error calculationKeyname ' + calculationKeyname + ' unknown');
          break;
      }
    } catch (e) {
      this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
    }

  }

  private unsubscribeAll() {
    this.formServiceOnButtonClickSubscription?.unsubscribe();
  }
}
